import React from "react";
import { ChecklistsList } from "../../../quality/checklists/list";

const HSE_KS_CREATE_SELECTOR_PROPS = {
  contextFields: {
    date: true,
    customer: true,
    project: true,
    folder: true,
    responsible: true,
  },
};

/**
 * HSE/KS Checklists List - Sjekklister (ISO 9001:2015 kap. 8.5)
 * Uses EnhancedChecklistSelector with required context fields for standalone creation.
 */
export const HseKsChecklistsList = () => {
  return <ChecklistsList createSelectorProps={HSE_KS_CREATE_SELECTOR_PROPS} />;
};
